import { Component, EventEmitter, Input, OnInit, Output, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-table',
    templateUrl: './table.component.html',
    styleUrls: ['./table.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class TableComponent implements OnInit {
  constructor() { }

  @Input() columns: string[] = [];
  @Input() list: any[] = [];
  @Input() isLoading: boolean = false;
  @Output() actionClicked = new EventEmitter<any>();
  @Output() actionEditClicked = new EventEmitter<any>();
  @Output() actionButtomClicked = new EventEmitter<any>();
  @Output() actionGenericClicked = new EventEmitter<any>();

  ngOnInit(): void {
  }

  onViewClick(item: any) {
    this.actionClicked.emit(item); 
  }

  onGenericClick(item: any, column: any) {
    this.actionGenericClicked.emit({ item, column });
  }

  onEditClick(item: any) {
    this.actionEditClicked.emit(item); 
  }

  onButtomClick(item: any) {
    console.log("action: ", this.isLoading)
    if(this.isLoading)
      return;

    this.actionButtomClicked.emit(item); 
  }
}